import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deleteLovedOne = async ({ lovedOneId, callerId }: { lovedOneId: string; callerId: string }): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation DeleteLovedOne($lovedOneId: String!, $callerId: String!) {
        deleteLovedOne(lovedOneId: $lovedOneId, callerId: $callerId)
      }
    `),
    variables: {
      lovedOneId,
      callerId,
    },
  });

  return response.data?.deleteLovedOne ?? false;
};
